module.exports = " <div class=portlet-title> <div class=\"caption text-success\">{{line.titulopagina}}</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/titulopagina.vue
// module id = 194
// module chunks = 0